import React from 'react'
import { foneMask } from '../../../../utils/masks'
import { TextField } from '@mui/material'
import { CadastroState } from '../../index'
import { Container } from './styles'
import classNames from 'classnames'
interface Props {
    fantasy_name: CadastroState
    setFantasy_name: (valor: string) => void
    email: CadastroState
    setEmail: (valor: string) => void
    fone: CadastroState
    setFone: (valor: string) => void
}

export default function CreateInitialDataStep({
    fantasy_name,
    setFantasy_name,
    email,
    setEmail,
    fone,
    setFone,
}: Props) {
    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.name === 'fone') {
            e.currentTarget.maxLength = 15
            let value = foneMask(e.target.value)
            setFone(value)
        }
    }
    return (
        <Container>
            <div>
                <label
                    htmlFor="fantasy_name"
                    className="text-gray-700 text-sm label block"
                >
                    Nome fantasia
                    <span className="text-red-500 required-dot">*</span>
                </label>
                <input
                    type="text"
                    id="fantasy_name"
                    onChange={(e) => setFantasy_name(e.target.value)}
                    value={fantasy_name}
                    className={classNames(
                        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                    )}
                    placeholder="Nome fantasia"
                />
                {/* <TextField
              onChange={(e) => setFantasy_name(e.target.value)} 
              value={fantasy_name}
              label='Nome fantasia'
              type='text'
            /> */}
            </div>
            <div>
                {/* <TextField
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    label="Email"
                    type="text"
                /> */}
                <label
                    htmlFor="email"
                    className="text-gray-700 text-sm label block"
                >
                    Email
                    <span className="text-red-500 required-dot">*</span>
                </label>
                <input
                    type="text"
                    id="email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    className={classNames(
                        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                    )}
                    placeholder="Email"
                />
            </div>

            <div>
                {/* <TextField
                    name="fone"
                    onChange={handleChange}
                    value={fone}
                    label="Telefone"
                    type="text"
                /> */}
                <label
                    htmlFor="fone"
                    className="text-gray-700 text-sm label block"
                >
                    Telefone
                    <span className="text-red-500 required-dot">*</span>
                </label>
                <input
                    type="text"
                    id="fone"
                    name="fone"
                    onChange={handleChange}
                    value={fone}
                    className={classNames(
                        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                    )}
                    placeholder="Telefone"
                />
            </div>
        </Container>
    )
}
